<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">

<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en" xml:lang="en">

<head>

  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">

  <meta name="viewport" content="width=device-width, initial-scale=1.0">

  <meta name="x-apple-disable-message-reformatting">

  <meta http-equiv="X-UA-Compatible" content="IE=edge">

  <title></title>

  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&display=swap" rel="stylesheet">

</head>

<body class="clean-body u_body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;">

  <table id="u_body" aria-describedby="u_body" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: middle;min-width: 320px;Margin: 0 auto;">

  <tbody style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;">

  <tr style="vertical-align: middle;">

    <th style="word-break: break-word;border-collapse: collapse !important;vertical-align: top">
      <div class="u-row-container">
        <div class="u-row">
          <div>

            <div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;">
              <div>
                <table id="u_content_text_6" class="common-style" aria-describedby="u_content_text_6_restricted_access_table">
                  <tbody>
                    <tr>
                      <th style="padding-top: 10%;">
                      </th>
                    </tr>
                  </tbody>
                </table>

                <table id="u_content_heading_2" aria-describedby="u_content_heading_2">
                  <tbody>
                    <tr>
                      <th class="v-container-padding-padding" style="overflow-wrap:break-word;word-break:break-word;padding:60px 60px 20px 60px;font-family:'Open Sans',sans-serif;">
                        <span style="padding-bottom: 25px;display: block; margin-top: 10em;"><img src="assets/user-warning.svg" alt="user warning"></span>
                        <h1 class="v-font-size" class="restricted-access">
                            Restricted Access
                        </h1>
                      </th>
                    </tr>
                  </tbody>
                </table>

                <table id="u_content_text_2" class="common-style" aria-describedby="u_content_text_2">
                  <tbody>
                    <tr>
                      <th class="v-container-padding-padding" style="overflow-wrap:break-word;word-break:break-word;padding:10px 60px;font-family: 'Poppins', sans-serif;">
                        <div style="line-height: 180%; text-align: left; word-wrap: break-word;">
                          <p class="restricted-access-para">
                            Malform found ,Unauthorised token
                          </p>
                        </div>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </th>
  </tr>
  </tbody>
  </table>
</body>
</html>